/**
 * Leitura pura da camada opcional "meta do colaborador" (Task 4) a partir do
 * mapa que a API devolve pronto, ao lado das linhas do GET
 * /campanhas/metas-campanha (Task 22): res.data.metas_colaborador[id_campanha_meta],
 * consumido por editarMeta (ModalCadastroMeta.vue) para reconstituir o
 * novaMetaForm ao reabrir uma meta.
 *
 * Antes desta task o front reconstruia esse mapa a partir das linhas cruas do
 * historico (uma por colaborador x modelo), precisando de dedupe por
 * id_colaborador porque o mesmo participante aparecia em N linhas. A API
 * passou a devolver a lista ja deduplicada, uma entrada por participante —
 * so resta normalizar os tipos e, principalmente, preservar o null da media
 * quando nao ha media (origem Informada nao tem media por definicao, e
 * colaborador sem historico tambem cai em null) — nunca forcar zero, que
 * ficaria indistinguivel de uma media que realmente deu zero. Ver
 * payloadMetaExtras.montarExtrasMeta para o mesmo cuidado no sentido inverso
 * (ida do payload).
 *
 * Os campos escalares da camada (origem, percentual de crescimento, piso,
 * bonus) vem repetidos em toda linha do grupo e sao lidos direto da propria
 * linha em editarMeta — nao precisam de tratamento aqui.
 *
 * piso_aplicado nao e gravado no banco (e so um selo visual de quando o piso
 * foi aplicado no calculo original, ver TabelaMetasCalculadas.vue) — sempre
 * false ao reabrir uma meta salva.
 */

/**
 * Monta form.metasCalculadas a partir da lista de participantes de uma meta,
 * ja deduplicada pela API (uma entrada por id_colaborador).
 *
 * `bonusGravado` carrega o valor_bonus que estava no banco. Nao e usado para
 * exibir nem para calcular nada — serve de PISO CONTRA PERDA DE DADO na
 * gravacao: se o usuario salvar a meta sem que a comissao P2 tenha sido
 * buscada nesta sessao (nao passou pela etapa de calculo, ou salvou com a
 * requisicao ainda em voo), o payload reenvia este valor em vez de mandar null
 * e apagar o que ja existia. Ver montarExtrasMeta.
 *
 * @param {Array<{id_colaborador:number, valor_media_referencia:?number, valor_meta:number, meta_manual:string, valor_bonus:?number}>} entradas
 * @returns {Object.<number, {media:?number, meta:number, manual:boolean, piso_aplicado:boolean, bonusGravado:?number}>}
 */
export function montarMetasCalculadas(entradas) {
  const metas = {};
  (entradas || []).forEach(entrada => {
    if (entrada.id_colaborador == null) return;
    metas[entrada.id_colaborador] = {
      media: entrada.valor_media_referencia != null ? Number(entrada.valor_media_referencia) : null,
      meta: entrada.valor_meta != null ? Number(entrada.valor_meta) : 0,
      manual: entrada.meta_manual === "S",
      piso_aplicado: false,
      bonusGravado: entrada.valor_bonus != null ? Number(entrada.valor_bonus) : null
    };
  });
  return metas;
}
